<template>
  <form @submit.prevent="handleSubmit" novalidate>
    <div class="form-group">
      <div class="title">
        <div class="tag hissu">必須</div>
        <div class="txt">ご希望の職種</div>
      </div>
      <div class="box">
        <select v-model="form.desired_job" :disabled="isLoading">
          <option value="">選択してください</option>
          <option v-for="opt in jobOptions" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
        </select>
        <p v-if="errors.desired_job" class="error-text">{{ errors.desired_job }}</p>
      </div>
    </div>

    <div class="form-group">
      <div class="title">
        <div class="tag hissu">必須</div>
        <div class="txt">医療機関ご経験年数</div>
      </div>
      <div class="box">
        <select v-model="form.experience_year" :disabled="isLoading">
          <option value="">選択してください</option>
          <option v-for="opt in experienceOptions" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
        </select>
        <p v-if="errors.experience_year" class="error-text">{{ errors.experience_year }}</p>
      </div>
    </div>

    <div class="form-group">
      <div class="title">
        <div class="tag ninni">任意</div>
        <div class="txt">ご希望の施設区分</div>
      </div>
      <div class="box">
        <select v-model="form.desired_workplace_type" :disabled="isLoading">
          <option value="">選択してください</option>
          <option v-for="opt in workplaceOptions" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
        </select>
      </div>
    </div>

    <div class="slide_control_group">
      <a href="#" class="prev" @click.prevent="handleBack">＜ 戻る</a>
      <button type="submit" class="form_button" :disabled="isLoading">次へ</button>
    </div>
  </form>
</template>

<script>
import { JOB_OPTIONS, EXPERIENCE_OPTIONS, WORKPLACE_OPTIONS } from '../../../lib/lp_gym01/constants'

export default {
  name: 'Step2Form',
  emits: ['submit', 'back'],
  props: {
    defaultValues: { type: Object, default: () => ({}) },
    isLoading: { type: Boolean, default: false }
  },
  data () {
    return {
      jobOptions: JOB_OPTIONS,
      experienceOptions: EXPERIENCE_OPTIONS,
      workplaceOptions: WORKPLACE_OPTIONS,
      form: {
        desired_job: this.defaultValues.desired_job || '',
        experience_year: this.defaultValues.experience_year != null ? this.defaultValues.experience_year : '',
        desired_workplace_type: this.defaultValues.desired_workplace_type || ''
      },
      errors: {}
    }
  },
  methods: {
    validate () {
      this.errors = {}
      if (!this.form.desired_job) this.errors.desired_job = 'ご希望の職種を選択してください'
      if (this.form.experience_year === '') this.errors.experience_year = '医療機関ご経験年数を選択してください'
      return Object.keys(this.errors).length === 0
    },
    handleSubmit () {
      if (!this.validate()) return
      this.$emit('submit', {
        ...this.form,
        experience_year: Number(this.form.experience_year)
      })
    },
    handleBack () {
      this.$emit('back', { ...this.form })
    }
  }
}
</script>

<style scoped>
.error-text {
  margin-top: 4px;
  font-size: 12px;
  color: #ef4444;
}
</style>
